import React, { useEffect } from "react";
import ComplyData from "../assests/JSON/Comply.json";
import "../styles/HowToComply.css";
import Seo from "../components/Seo";

const HowToComply = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);
  return (
    <section className="howtocomply-container">
        <Seo path="/how-to-comply" />
      <h2 className="howtocomply-heading">{ComplyData.heading}</h2>

      <ul className="howtocomply-list">
        {ComplyData.steps.map((step, index) => (
          <li key={index}>{step}</li>
        ))}
      </ul>

      {ComplyData.imagePath && (
        <div className="howtocomply-image">
          {/* <img
            src={require(`../assests/${ComplyData.imagePath}`)}
            alt="E-invoicing Compliance"
          /> */}
        </div>
      )}
    </section>
  );
};

export default HowToComply;
